/**
 * Device Resource
 *
 * Thin 1:1 mapping to the device API. No business logic, no default
 * parameter injection. The SDK passes params as-is.
 */

import type { HttpLayer } from '../http.js';
import type { Device, RegisterDeviceRequest, CreateDeviceRequest } from '../types/index.js';

export class DeviceResource {
  constructor(private http: HttpLayer) {}

  private prefix = '/v1/device';

  // --- Health ---

  /**
   * Liveness probe. `unauthenticated`: `/healthz` is gateway-exempt
   * (`authExemptPrefixes` in `go/internal/api/middleware.go`) and must answer
   * before a user has any credential — that is what a health check is for.
   */
  async healthCheck(): Promise<{ status: string }> {
    await this.http.get('/healthz', undefined, { unauthenticated: true });
    return { status: 'healthy' };
  }

  // --- Devices ---

  async createDevice(params: CreateDeviceRequest): Promise<Device> {
    return this.http.post(`${this.prefix}/devices`, params);
  }

  async registerDevice(params: RegisterDeviceRequest): Promise<Device> {
    return this.http.post(`${this.prefix}/register`, params);
  }
}
